import React from "react";
import InputMask from "react-input-mask";

import * as S from "../styles";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import useCreditCardFlagSVG from "../../../hooks/useCreditCardFlagSVG";
import { IMAGE_DEFAULT_CREDIT_CARD } from 'app/constants/creditCard';
import CollapsibleSection from "./CollapsibleSection";

const CardSection = ({ formik, completed, active, hidden }) => {
  const err = field => formik.errors[field] && formik.touched[field];
  const { svg } = useCreditCardFlagSVG({ cardNumber: formik.values.card_number });

  if (hidden) return null;

  const last4 = formik.values.card_number.replace(/\D/g, "").slice(-4);

  return (
    <CollapsibleSection
      title="Adicionar dados do cartão de crédito"
      step={2}
      active={active}
      completed={completed}
      summary={
        <>
          <img
            alt="bandeira"
            src={svg ? toAbsoluteUrl(svg) : IMAGE_DEFAULT_CREDIT_CARD}
          />
          Cartão de crédito - {last4}
        </>
      }
    >
      <S.Grid cols={2}>
        <S.Field>
          <label>
            Nome impresso no cartão <span className="req">*</span>
          </label>
          <input
            name="cardholder_name"
            type="text"
            className={`form-control ${err("cardholder_name") ? "is-invalid" : ""}`}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.cardholder_name}
          />
          {err("cardholder_name") && (
            <span className="err">{formik.errors.cardholder_name}</span>
          )}
        </S.Field>

        <S.Field>
          <label>
            Número do cartão <span className="req">*</span>
          </label>
          <S.InputAdornment>
            <InputMask
              name="card_number"
              placeholder="0000 0000 0000 0000"
              mask="9999 9999 9999 9999"
              maskChar={null}
              className={`form-control ${err("card_number") ? "is-invalid" : ""}`}
              type="tel"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.card_number}
            />
            <img
              alt="bandeira"
              src={svg ? toAbsoluteUrl(svg) : IMAGE_DEFAULT_CREDIT_CARD}
            />
          </S.InputAdornment>
          {err("card_number") && (
            <span className="err">{formik.errors.card_number}</span>
          )}
        </S.Field>

        <S.Field>
          <label>
            Vencimento (MM/AA) <span className="req">*</span>
          </label>
          <InputMask
            name="card_expiration"
            placeholder="MM / AA"
            mask="99 / 99"
            maskChar={null}
            className={`form-control ${err("card_expiration") ? "is-invalid" : ""}`}
            type="tel"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.card_expiration}
          />
          {err("card_expiration") && (
            <span className="err">{formik.errors.card_expiration}</span>
          )}
        </S.Field>

        <S.Field>
          <label>
            CVV <span className="req">*</span>
          </label>
          <InputMask
            name="card_cvv"
            placeholder="000"
            mask="9999"
            maskChar={null}
            className={`form-control ${err("card_cvv") ? "is-invalid" : ""}`}
            type="tel"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.card_cvv}
          />
          {err("card_cvv") && (
            <span className="err">{formik.errors.card_cvv}</span>
          )}
        </S.Field>
      </S.Grid>
    </CollapsibleSection>
  );
};

export default CardSection;
